import { Grid, useMediaQuery } from "@mui/material";
import { Visibility } from "@mui/icons-material";

import { ListAction, ListActions, StyledListItem, StyledListWrapper, StyledPagination } from "@framework/styled";
import type { IToken } from "@framework/types";
import { ModuleType, TokenStatus, TokenType } from "@framework/types";
import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { useDialogView, useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { Erc721TokenDialogView, ServiceType, TokenSearchForm } from "@framework/shared";
import { List } from "@dzambalaorg/ui-kit";

const LOOT_TOKEN_URL = "/loot/tokens";
const LOOT_TOKEN_VIEW_DIALOG_KEY = "lootTokens";

export const LootToken = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IToken>
  >(LOOT_TOKEN_URL, { enableInfiniteScroll: isMd }, void 0, {
    tokenStatus: [TokenStatus.MINTED],
  });

  const { viewItem, handleView } = useDialogView<IToken>();

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "loot", "loot.tokens"]} />

      <PageHeader message="pages.loot.tokens.title" />

      <TokenSearchForm
        initialSearchValues={{
          tokenStatus: [TokenStatus.MINTED],
        }}
        service={ServiceType.ADMIN}
        contractModule={[ModuleType.LOOT]}
        contractType={[TokenType.ERC721]}
      />

      <ProgressOverlay isLoading={isLoading}>
        <StyledListWrapper count={allRows.length} isLoading={isLoading}>
          {allRows.map(token => (
            <StyledListItem key={token.id}>
              <List.ItemText>{token.template?.title}</List.ItemText>
              <ListActions>
                <ListAction
                  onClick={handleView(LOOT_TOKEN_VIEW_DIALOG_KEY, token, "view")}
                  message="form.tips.view"
                  icon={Visibility}
                />
              </ListActions>
            </StyledListItem>
          ))}
        </StyledListWrapper>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}

      <Erc721TokenDialogView viewItem={viewItem} />
    </Grid>
  );
};
